import Ticket from '../model';
import ModelFactory from '../../model-factory';

export default class Problem extends Ticket {
  constructor(data = {}) {
    super(data);
  }
}

export const modelFactory = new ModelFactory('pr', (data) => new Problem(data));
